import { Typography } from "@mui/material";
import React from "react";
import "./noResults.scss";

export const NoResultsFound = ({
  message = "No Results Found",
  headerType = "h1",
}) => {
  return (
    <div className="no-results-message ">
      <Typography className={headerType}>{message}</Typography>
    </div>
  );
};

export default NoResultsFound;
